module.exports = __webpack_public_path__ + "img/lg_ring_0_0_0_null.4595a51f.png";